import type { CommunityAction, EducationItem, LocationItem } from '../types';
import { idbGet, idbSet } from './storage';

type Manifest = {
  version: string;
  datasets: Record<string, string>;
};

type CacheEnvelope<T> = {
  version: string;
  data: T;
};

async function loadManifest(): Promise<Manifest> {
  const response = await fetch('/data/manifest.json');
  if (!response.ok) throw new Error('Manifest data tidak dapat dimuat');
  return response.json() as Promise<Manifest>;
}

async function loadVersioned<T>(key: string, path: string, version: string): Promise<T> {
  const cached = await idbGet<CacheEnvelope<T>>(`dataset:${key}`);
  if (cached?.version === version) return cached.data;

  const response = await fetch(path);
  if (!response.ok) throw new Error(`Dataset ${key} gagal dimuat`);
  const data = (await response.json()) as T;
  await idbSet(`dataset:${key}`, { version, data });
  return data;
}

export async function getLocations(): Promise<LocationItem[]> {
  const manifest = await loadManifest();
  return loadVersioned<LocationItem[]>('locations', manifest.datasets.locations, manifest.version);
}

export async function getEducation(): Promise<EducationItem[]> {
  const manifest = await loadManifest();
  return loadVersioned<EducationItem[]>('education', manifest.datasets.education, manifest.version);
}

export async function getActions(): Promise<CommunityAction[]> {
  const manifest = await loadManifest();
  return loadVersioned<CommunityAction[]>('actions', manifest.datasets.actions, manifest.version);
}
